module.exports = __webpack_public_path__ + "static/media/04-mobile-menu.3471f25b.png";